module.exports = __webpack_public_path__ + "assets/images/scrolly-test/3-desktop.jpg?v=cfab1277";